<template>
  <div ref="chartRef" style="width: 100%;height: 100%"></div>
</template>

<script setup>
import * as echarts from "echarts";
import { nextTick, onMounted, ref, watch } from "vue";

const props = defineProps(["data"]);

const chartRef = ref(null);
let chartInstance = null;

const init = () => {
  chartInstance = echarts.init(chartRef.value);
};

onMounted(() => {
  nextTick(() => {
    init();
  })
});

watch(
  () => props.data,
  (val) => {
    setChart(val);
  },
  { deep: true }
);

const setChart = (val) => {
  const option = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      bottom: '5%',
      left: 'center',
      icon: "circle", // 设置图例的图标为圆形
      itemGap: 40, // 设置间距
      itemWidth: 10, // 设置图例标记的图形宽度
      data: [
        { name: "关注人数", textStyle: { color: "#FF7A68" } },
        { name: "轻度人数", textStyle: { color: "#FDC631" } },
        { name: "正常人数", textStyle: { color: "#6FCAF7" } },
      ],
    },
    graphic: {
      type: "text",
      left: "center",
      top: "middle",
      style: {
        text: `${val.effectivityEvaluationNum}人\n有效采集数`,
        textAlign: "center",
        fill: "#6fcaf7",
        fontSize: 16,
        lineHeight: 25,
      },
    },
    series: [
      {
        name: "",
        type: "pie",
        radius: ["40%", "70%"],
        avoidLabelOverlap: false,
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 0,
        },
        label: {
          show: true, // 显示标签
          position: "inside", // 标签显示在扇形区域内
          formatter: "{d}%", // 显示数据值
          color: "#fff", // 标签文字颜色
          fontSize: 14,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: "bold",
            color: "#fff",
          },
        },
        labelLine: {
          show: false, // 隐藏标签连线
        },
        data: [
          { value: val.concernPeopleNum, name: "关注人数" },
          { value: val.mildPeopleNum, name: "轻度人数" },
          { value: val.normalPeopleNum, name: "正常人数" },
        ],
        color: [
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#FF573C" },
            { offset: 1, color: "#FFB2AF" },
          ]),
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#FF9400" },
            { offset: 1, color: "#FFCF8E" },
          ]),
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#5FB9FE" },
            { offset: 1, color: "#A5F3FF" },
          ]),
        ], // 设置颜色数组
      },
    ],
  };
  chartInstance && chartInstance.setOption(option);
            // 窗口尺寸变化时自动调整图表大小
        window.addEventListener('resize', function() {
            chartInstance.resize();
        });
}

</script>

<style lang="scss" scoped>

</style>